import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../../actions/commonActions";
import { FETCH_BATTLE_CARD_FAILURE, FETCH_BATTLE_CARD_REQUEST, FETCH_BATTLE_CARD_SUCCESS } from "../../actions/opportunities/battleCardActions";

  const initialState = {
    battleCardLoading: false,
    battleCardData: [],
    battleCardError: null,
  };
  
  const battleCardReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_BATTLE_CARD_REQUEST:
        return { ...state, battleCardLoading: true , payload: action.payload};
      case FETCH_BATTLE_CARD_SUCCESS:
        return { ...state, battleCardLoading: false, battleCardData: action.payload };
      case FETCH_BATTLE_CARD_FAILURE:
        return { ...state, battleCardLoading: false, battleCardError: action.payload };   
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
              return initialState         
      default:
        return state;
    }
  };
  
  export default battleCardReducer;
  